export type Count = ['count', number];
export const Count = (count: number): Count => ['count', count];
export const increment = <T extends [unknown, number]>([type, value]: T): T =>
  [type, value + 1] as T;

export type AccountId = ['account_id', number];
export const AccountId = (id: number): AccountId => ['account_id', id];

export type UserId = ['user_id', number];
export const UserId = (id: number): UserId => ['user_id', id];

export type CompanyId = ['company_id', number];
export const CompanyId = (id: number): CompanyId => ['company_id', id];

export type PermissionId = ['permission_id', number];
export const PermissionId = (id: number): PermissionId => ['permission_id', id];

export type ProjectId = ['project_id', number];
export const ProjectId = (id: number): ProjectId => ['project_id', id];

export type ProjectPhaseId = ['project_phase_id', number];
export const ProjectPhaseId = (id: number): ProjectPhaseId => [
  'project_phase_id',
  id,
];

export type ProjectConversationId = ['project_conversation_id', number];
export const ProjectConversationId = (id: number): ProjectConversationId => [
  'project_conversation_id',
  id,
];

export type TemplateId = ['template_id', number];
export const TemplateId = (id: number): TemplateId => ['template_id', id];

// TODO: Split types, or depend on ProjectId instead of number
export type TaskId = ['task_id', number, number];
export const TaskId = (projectId: number, taskId: number): TaskId => [
  'task_id',
  projectId,
  taskId,
];

export type TaskIdV2 = ['task_id', number];
export const TaskIdV2 = (taskId: number): TaskIdV2 => ['task_id', taskId];

export type DocumentId = ['document_id', number];
export const DocumentId = (documentId: number): DocumentId => [
  'document_id',
  documentId,
];

export type SpaceId = ['space_id', number, number];
export const SpaceId = (projectId: number, spaceId: number): SpaceId => [
  'space_id',
  projectId,
  spaceId,
];

export type SpaceTabId<T> = ['space_tab_id', number, number, T];
export const SpaceTabId = <T>(
  projectId: number,
  spaceId: number,
  spaceTabId: T,
): SpaceTabId<T> => ['space_tab_id', projectId, spaceId, spaceTabId];

export type StatusUpdateId = ['status_update_id', number];
export const StatusUpdateId = (statusUpdateId: number): StatusUpdateId => [
  'status_update_id',
  statusUpdateId,
];

export type ApprovalId = ['approval_id', TaskId[1], TaskId[2], number];
export const ApprovalId = (
  [, projectId, taskId]: TaskId,
  approvalId: number,
): ApprovalId => ['approval_id', projectId, taskId, approvalId];

export type FormInstanceId = ['form_instance_id', number, number];
export const FormInstanceId = (
  projectId: number,
  instanceId: number,
): FormInstanceId => ['form_instance_id', projectId, instanceId];

export * from './core-types';
